import $ from 'jquery';
import _ from 'underscore';
import Backbone from 'backbone';

import AccountProfile from 'models/account_profile';
import User from 'models/user';
import Form from 'views/form';
import Notifications from 'views/notifications';
import Nav from 'views/nav';
import VerifyPhone from 'views/verify_phone';


export default Backbone.View.extend({

  initialize: function (options) {
    _.bindAll.apply(_, [this].concat(_.functions(this)));

    this.$carousel = null;
    this.forms = {};
    this.model = new User();
    this.notification_view = null;

    this.starting_slide = options.starting_slide || 0;
    this.register_activity_id = options.register_activity_id;
    this.profile = options.profile || new AccountProfile();
    this.nav = new Nav({ el: $('nav.navbar') });

    // Some function aliases (much less code than spelling them out)
    this.notifications_cancelled = this.remove;
    this.verify_phone_cancelled = this.slide_carousel('prev');
    this.verify_phone_submitted = this.remove;
    this.apps_cancelled = this.slide_carousel(1);
    this.apps_submitted = this.remove;

    // Templates
    this.register_tmpl = _.template($('#register-template').html());
  },

  carousel_sliding: function () {
    this.$carousel.addClass('sliding');
  },

  slide_carousel: function (slide) {
    // Returns a function that takes the carousel to the specified slide
    return function () {
      this.$carousel.carousel(slide);
    }.bind(this);
  },

  registration_submitted: function (model) {
    this.nav.logged_in(model.get('username'));
    this.trigger('registered', model);
    this.profile.fetch({
      cache: false,
      success: this.slide_carousel('next')
    });
  },

  notifications_submitted: function (profile) {
    var slide = profile.get('notification_type') === 'S' ? 2 : 3;
    if (mobile && profile.get('notification_type') === 'P') {
      this.remove();
    } else {
      this.$carousel.carousel(slide);
    }
  },

  get_form_model: function (form_id) {
    return form_id === 'registration' ? this.model : this.profile;
  },

  remove: function () {
    this.trigger('removing');
    Backbone.View.prototype.remove.apply(this);
  },

  render: function () {
    if (_.keys(this.forms).length === 0) {
      // Add HTML, setup forms and carousel
      this.$el.html(this.register_tmpl({
        starting_slide: this.starting_slide,
      }));
      this.$carousel = $('.carousel', this.$el);
      _.each($('.item', this.$carousel), function (item) {
        var $form = $('form', item),
          form_id = $form.data('form-id');
        this.forms[form_id] = new Form({
          el: $form,
          errors: {},
          model: this.get_form_model(form_id),
        });
        this.forms[form_id].on('submitted', this[form_id + '_submitted']);
        this.forms[form_id].on('cancelled', this[form_id + '_cancelled']);
      }, this);
      this.$carousel
        .on('slid.bs.carousel', this.render)
        .on('slide.bs.carousel', this.carousel_sliding);
    }
    this.$carousel.removeClass('sliding');

    // Determine the active slide/form and render it
    var $active_slide = $('.item.active', this.$carousel),
      $active_form = $('form', $active_slide),
      active_form_id = $active_form.data('form-id');
    this.forms[active_form_id].render();
    if (active_form_id === 'notifications' && !this.notificationsView) {
      this.notificationsView = new Notifications({
        el: $active_slide,
        form: this.forms.notifications,
      });
      this.notificationsView.render();
    } else if (active_form_id === 'verify_phone' && !this.verify_phone_view) {
      this.verify_phone_view = new VerifyPhone({
        el: $active_slide,
        form: this.forms.verify_phone,
      });
    }
  },
});



// WEBPACK FOOTER //
// ./static/js/views/register.js